import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Button from '@dbk/ui-buttons';
// import '../../../../src/assets/styles/hrmw-mcd.scss'; // commented due to color contrast tool checker issue
import isEnterorSpaceKeyPressed from '../../../utils/isEnterorSpaceKeyPressed';

class DeleteContactModal extends Component {
	constructor(props) {
		super(props);
		this.state=({
			confirmDeleteYes: true,
			confirmDeleteNo: false
		});
	}

	confirmDelete = async (deleteConfirm, e) => {
		if(isEnterorSpaceKeyPressed(e)){
			if(deleteConfirm) {
				await this.props.hrmw.setDeletedContactList(this.props.selectedContact);
			}
			this.props.deleteContactRow();
		}
	}
  /* WMCE-27158  Removed filterButton style of buttons */
	render() {
		const { i18n: { messages }, selectedContact } = this.props;
		return (
			<div>
				<div tabIndex={0} className="row small-12 medium-12 large-12 headerMargin">
					{messages['app.manageContactDetails.deleteContact.message']} &nbsp;
					"{selectedContact.emailId ? selectedContact.emailId : (selectedContact.fax ? "+"+selectedContact.fax.countryCode+" "+selectedContact.fax.phoneNo : "+"+selectedContact.phone.countryCode+" "+selectedContact.phone.phoneNo)}"
					&nbsp;{messages['app.manageContactDetails.deleteContact.for']}
					&nbsp;{selectedContact.person.name ? selectedContact.person.name : `${selectedContact.person.firstName} ${selectedContact.person.lastName}`} ?
				</div>
				<div className="row columns small-12 medium-12 large-12">
					<div className="columns large-2 medium-2 small-12 rightAligned">
						<Button fullWidth  size='normal' onKeyDown={(e)=>this.confirmDelete(this.state.confirmDeleteYes, e)} onClick={()=>this.confirmDelete(this.state.confirmDeleteYes)} >
							{messages['app.common.alert.yes']}
						</Button>
					</div>
					<div className="columns large-2 medium-2 small-12 rightAligned">
						<Button fullWidth  tertiary size='normal' onKeyDown={(e)=>this.confirmDelete(this.state.confirmDeleteNo, e)} onClick={()=>this.confirmDelete(this.state.confirmDeleteNo)}>
							{messages['app.common.alert.no']}
						</Button>
					</div>
				</div>
			</div>
		)
	}
}

export default createContainer({
	$queries: {
		i18n: {
			messages: true,
		},
		hrmw: {
			setDeletedContactList: { $call: 'setDeletedContactList' }
		},
	}
})(DeleteContactModal);